<template>

    <div class="container-anime">

        <img class="img-1" src="/img/magic/mail-sent-empty.svg">

        <img :class="{ 'img-2-anim': wip }" class="img-2" src="/img/magic/airplane.svg">

    </div>

</template>

<script>

export default {

    name: 'airplane',

    data() {

        return {
            wip: false
        }

    },

    methods: {

        launch() {

            this.wip = true

            const self = this

            setTimeout(function () {
                self.wip = false
            }, 4000)

        }
    }
}
</script>

<style lang="scss" scoped>

.container-anime {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.img-1 {
    width: 100%;
    height: 100%;
}

.img-2 {
    width: 50%;
    object-fit: contain;
    position: absolute;
    left: 25%;
}

.img-2-anim {
    animation: fly 4s linear 0.2s 1 normal;
}

@keyframes fly {

    0% {
        width: 50%;
        transform: scaleX(1);
        left: 25%;
    }

    5% {
        width: 50%;
        transform: scaleX(1);
        left: 100%;
    }

    30% {
        width: 10%;
        transform: scaleX(-1);
        left: 100%;
    }

    50% {
        width: 5%;
        transform: scaleX(-1);
        left: 45%;
    }

    90% {
        width: 10%;
        transform: scaleX(-1);
        left: -50%;
    }

    91% {
        width: 50%;
        transform: scaleX(1);
        left: -50%;
    }

    100% {
        width: 50%;
        transform: scaleX(1);
        left: 25%;
    }
}

</style>
